export const getIsMobile = () => {
  if (typeof navigator === 'undefined') return false;

  const userAgent = navigator.userAgent || navigator.vendor;

  return /android|iphone|ipad|ipod|windows phone|blackberry|webos/i.test(userAgent);
};
